import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-053442a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "box-img" }
const _hoisted_4 = { class: "text-overflow-2 card-title" }
const _hoisted_5 = { class: "price" }

import { IVariant } from '@/types/product';
  import _ from 'lodash';
  import { request } from '@/utils';

  export interface IProps {
    modelValue: IVariant
  }

  export interface IEmits {
    (event: 'update:model-value', variant: IVariant): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:model-value', variant: IVariant): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: IVariant
  }

  

  

  const handleToggleCollect = async () => {
    const { id, follow } = props.modelValue;
    const body = { action_type: 'follow', target_type: 'Bean::Variant', target_id: id };
    if (follow) {
      await request.delete('/action_stores', { params: body });
    } else {
      await request.post('/action_stores', body);
    }
    emits('update:model-value', { ...props.modelValue, follow: !follow });
  };


return (_ctx: any,_cache: any) => {
  const _component_AppAutoHeight = _resolveComponent("AppAutoHeight")!
  const _component_AppPrice = _resolveComponent("AppPrice")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'variant.detail', params: { id: __props.modelValue.id } },
    class: "relative card-variant"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "btn-collect",
        onClick: _withModifiers(handleToggleCollect, ["prevent"])
      }, [
        _createElementVNode("img", {
          class: "icon-heart",
          src: __props.modelValue.follow ? require('@/assets/icon/heart.png') : require('@/assets/icon/heart-default.png')
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppAutoHeight, {
          height: "100%",
          "image-url": _unref(_).get(__props.modelValue, 'product.images[0].url')
        }, null, 8, ["image-url"])
      ]),
      _createElementVNode("h6", _hoisted_4, _toDisplayString(__props.modelValue.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppPrice, {
          value: __props.modelValue.cost_price
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})